import { LATEST_SCAN_SORT } from '../../../shared/projectsV2/sorting';

export const DEFAULT_PAGE = 1;
export const DEFAULT_COUNT = 10;
export const DEFAULT_SORT = LATEST_SCAN_SORT.DESC;
export const DEFAULT_TITLE = '';
